<template>
    <header
        class="navbar sticky-top flex-md-nowrap p-0"
        :class="{
            'navbar-auth': !noData,
            'navbar-guest': noData,
        }"
        data-bs-theme="dark"
    >
        <div v-if="!noData" class="navbar-auth-content">
            <button
                type="button"
                class="sidebar-trigger"
                aria-label="Recolher / expandir menu"
                @click="toggleSidebar"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect width="18" height="18" x="3" y="3" rx="2"/>
                    <path d="M9 3v18"/>
                </svg>
            </button>

            <div class="platform-badge">
                <svg class="platform-badge-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 18" fill="none">
                    <path d="M18.7655 7.97305V15.9423C18.7655 16.4474 18.5905 16.875 18.2405 17.225C17.8905 17.575 17.4629 17.75 16.9578 17.75H3.07316C2.56804 17.75 2.14048 17.575 1.79048 17.225C1.44048 16.875 1.26548 16.4474 1.26548 15.9423V7.95383C0.862913 7.62304 0.560663 7.19388 0.35873 6.66633C0.156813 6.13876 0.152647 5.56921 0.34623 4.95768L1.35778 1.65383C1.49111 1.23333 1.7174 0.894225 2.03663 0.636525C2.35586 0.378842 2.73727 0.25 3.18086 0.25H16.8308C17.2744 0.25 17.6533 0.373076 17.9674 0.619226C18.2815 0.865376 18.5103 1.20383 18.6539 1.6346L19.6847 4.95768C19.8783 5.56921 19.8741 6.13683 19.6722 6.66055C19.4703 7.18427 19.168 7.62177 18.7655 7.97305ZM12.2155 7.25C12.7616 7.25 13.1722 7.08301 13.4472 6.74903C13.7222 6.41506 13.8347 6.05641 13.7847 5.67308L13.177 1.74995H10.7655V5.69998C10.7655 6.12049 10.9078 6.48396 11.1924 6.79038C11.477 7.09679 11.818 7.25 12.2155 7.25ZM7.71546 7.25C8.17572 7.25 8.54913 7.09679 8.83568 6.79038C9.12221 6.48396 9.26548 6.12049 9.26548 5.69998V1.74995H6.85391L6.2462 5.71153C6.19237 6.06666 6.30391 6.41185 6.58083 6.7471C6.85776 7.08237 7.23597 7.25 7.71546 7.25ZM3.26546 7.25C3.63597 7.25 3.95457 7.12083 4.22125 6.8625C4.48792 6.60415 4.65266 6.27947 4.71548 5.88845L5.30395 1.74995H3.18086C3.07187 1.74995 2.98533 1.77399 2.92123 1.82208C2.85711 1.87016 2.80903 1.94228 2.77698 2.03845L1.81546 5.29228C1.68339 5.72178 1.74556 6.15544 2.00198 6.59325C2.2584 7.03109 2.67955 7.25 3.26546 7.25ZM16.7655 7.25C17.3065 7.25 17.7206 7.0375 18.0078 6.6125C18.295 6.18748 18.3642 5.74741 18.2155 5.29228L17.204 2.0192C17.1719 1.92305 17.1238 1.85413 17.0597 1.81245C16.9956 1.77078 16.9091 1.74995 16.8001 1.74995H14.727L15.3155 5.88845C15.3783 6.27947 15.543 6.60415 15.8097 6.8625C16.0763 7.12083 16.3949 7.25 16.7655 7.25Z" fill="currentColor"/>
                </svg>
                <span class="platform-badge-text">Marketplace</span>
            </div>

            <div
                class="status-group"
                v-if="$store.state.completeConfig && navbarData?.time"
            >
                <div
                    class="status-item"
                    :class="navbarData?.open ? 'status-open' : 'status-closed'"
                    v-tippy="statusTooltip"
                >
                    <span class="status-dot">
                        <span class="status-dot-ping"></span>
                        <span class="status-dot-core"></span>
                    </span>
                    <span class="status-label">
                        {{ navbarData?.open ? 'Aberto' : 'Fechado' }}
                    </span>
                </div>
            </div>

            <div class="profile-section" ref="profileSection">
                <div class="profile-info">
                    <div class="profile-avatar" v-if="sidebarData?.logo">
                        <img :src="sidebarData.logo" :alt="sidebarData?.company" />
                    </div>
                    <div class="profile-avatar profile-avatar-letter" v-else>
                        {{ companyInitial }}
                    </div>
                    <div class="profile-text">
                        <p class="profile-name truncate">{{ sidebarData?.company }}</p>
                        <p class="profile-address truncate">{{ sidebarData?.address }}</p>
                    </div>
                </div>
                <button
                    type="button"
                    class="profile-toggle"
                    aria-label="Opções do restaurante"
                    @click="profileOpen = !profileOpen"
                >
                    <span class="icon-chevron" :class="{ rotated: profileOpen }"></span>
                </button>
                <div class="profile-dropdown" v-show="profileOpen">
                    <button type="button" class="profile-dropdown-item" @click="logout">
                        <svg
                            class="profile-logout-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            aria-hidden="true"
                        >
                            <path d="m16 17 5-5-5-5" />
                            <path d="M21 12H9" />
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                        </svg>
                        Sair
                    </button>
                </div>
            </div>
        </div>

        <!-- Header de login/cadastro -->
        <div v-else class="row content navbar-guest-content">
            <div class="col">
                <a class="navbar-brand icon-arrow-left" href="#" v-if="withBack" @click.prevent="backStep()"></a>
            </div>
            <div class="col-2 text-center">
                <img src="~@/assets/img/logo_principal.png" class="logo" alt="Prattu">
            </div>
            <div class="col p-0 text-end">
                <router-link v-if="loggedIn === 1" class="navbar-brand input-base btn-round no-hover login" to="/login">
                    <span class="text">Já tem conta?</span> <span class="time bold-700">Entrar</span>
                </router-link>
                <router-link v-if="loggedIn === 2" class="navbar-brand input-base btn-round no-hover login" to="/">
                    <span class="text">Não tem conta?</span> <span class="time bold-700">Cadastrar</span>
                </router-link>
            </div>
        </div>
    </header>
</template>

<script>
import { mapState } from 'vuex';
import { emitter } from '@/store';

export default {
    name: "Navbar",
    props: {
        withSidebar: Boolean,
        withBack: Boolean,
        noData: Boolean,
        loggedIn: Number,
    },
    data() {
        return {
            profileOpen: false,
        };
    },
    computed: {
        ...mapState(['navbarData', 'sidebarData']),
        companyInitial() {
            const name = this.sidebarData?.company || '';
            return name.charAt(0).toUpperCase() || 'P';
        },
        statusTooltip() {
            if (!this.navbarData?.time) return undefined;

            if (this.navbarData.open) {
                const hoursLine = `Aberto: ${this.navbarData.time}`;
                const preparationLine = this.navbarData.preparation
                    ? `Preparo: ${this.navbarData.preparation}`
                    : '';

                return {
                    content: preparationLine
                        ? `${hoursLine}<br>${preparationLine}`
                        : hoursLine,
                    allowHTML: true,
                    theme: 'navbar-status',
                    placement: 'bottom',
                    offset: [0, 8],
                    arrow: false,
                    delay: [200, 0],
                };
            }

            return {
                content: `Fechado: reabre às ${this.navbarData.time}`,
                allowHTML: true,
                theme: 'navbar-status',
                placement: 'bottom',
                offset: [0, 8],
                arrow: false,
                delay: [200, 0],
            };
        },
    },
    methods: {
        toggleSidebar() {
            emitter.emit('toggleSidebar');
        },
        backStep() {
            this.$emit('backStep');
        },
        logout() {
            this.profileOpen = false;
            this.$store.dispatch('resetStore');
            this.$router.push('/login');
        },
        handleClickOutside(event) {
            if (this.profileOpen && this.$refs.profileSection && !this.$refs.profileSection.contains(event.target)) {
                this.profileOpen = false;
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
};
</script>

<style lang="scss" scoped>
    .navbar {
        height: 70px;
        position: fixed;
        top: 0;
        right: 0;
        z-index: 1050;
        transition: left 0.2s ease;
    }

    .navbar-auth {
        left: var(--sidebar-width, 48px);
        background-color: $white-primary;
        border-bottom: 1px solid $gray-line;
        box-shadow: none;
    }

    .navbar-guest {
        left: 0;
        background-color: $black-secondary;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    }

    .navbar-auth-content {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 0 16px 0 20px;
        gap: 12px;
    }

    .sidebar-trigger {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border: none;
        border-radius: 8px;
        background: transparent;
        color: $black-primary;
        cursor: pointer;
        flex-shrink: 0;
        transition: background-color 0.15s;

        &:hover {
            background-color: $gray-tab;
        }
    }

    .platform-badge {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 10px;
        border-radius: 8px;
        background-color: rgba($green-primary, 0.1);
        border: 1px solid rgba($green-primary, 0.2);
        flex-shrink: 0;
    }

    .platform-badge-icon {
        color: $green-primary;
        flex-shrink: 0;
    }

    .platform-badge-text {
        font-size: 12px;
        font-weight: 600;
        color: $green-primary;
        line-height: 1;
    }

    .status-group {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-shrink: 0;
    }

    .status-item {
        display: flex;
        align-items: center;
        gap: 6px;
        cursor: default;
        user-select: none;
    }

    .status-dot {
        position: relative;
        display: flex;
        width: 10px;
        height: 10px;
        flex-shrink: 0;
    }

    .status-dot-ping {
        position: absolute;
        display: inline-flex;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        opacity: 0.75;
        animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
    }

    .status-open .status-dot-ping {
        background-color: $light-green;
    }

    .status-closed .status-dot-ping {
        background-color: $red-primary;
    }

    .status-dot-core {
        position: relative;
        display: inline-flex;
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }

    .status-open .status-dot-core {
        background-color: $light-green;
    }

    .status-closed .status-dot-core {
        background-color: $red-primary;
    }

    .status-label {
        font-size: 12px;
        font-weight: 500;
        line-height: 1.2;

        @media (max-width: 575.98px) {
            display: none;
        }
    }

    .status-open .status-label {
        color: $green-primary;
    }

    .status-closed .status-label {
        color: $red-primary;
    }

    .profile-section {
        position: relative;
        display: flex;
        align-items: center;
        gap: 4px;
        margin-left: auto;
        min-width: 0;
    }

    .profile-info {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
    }

    .profile-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid $gray-line;
        overflow: hidden;
        flex-shrink: 0;
        background-color: $white-primary;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .profile-avatar-letter {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba($green-primary, 0.12);
        color: $green-primary;
        font-size: 14px;
        font-weight: 700;
        border-color: rgba($green-primary, 0.2);
    }

    .profile-text {
        min-width: 0;
        display: none;

        @media (min-width: 576px) {
            display: block;
        }
    }

    .profile-name {
        font-size: 14px;
        font-weight: 600;
        color: $black-primary;
        line-height: 1.2;
        margin: 0;
        max-width: 160px;
    }

    .profile-address {
        font-size: 12px;
        color: $gray-primary;
        line-height: 1.2;
        margin: 0;
        max-width: 160px;
    }

    .profile-toggle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border: none;
        border-radius: 8px;
        background: transparent;
        cursor: pointer;
        flex-shrink: 0;
        transition: background-color 0.15s;

        &:hover {
            background-color: $gray-tab;
        }
    }

    .icon-chevron {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-image: url("~@/assets/img/arrow_drop_down.svg");
        background-size: 16px 16px;
        background-repeat: no-repeat;
        background-position: center;
        opacity: 0.6;
        transition: transform 0.2s;
        /* SVG aponta para cima — fechado = para baixo */
        transform: rotate(180deg);

        &.rotated {
            /* Aberto = para cima */
            transform: rotate(0deg);
        }
    }

    .profile-dropdown {
        position: absolute;
        top: calc(100% + 6px);
        right: 0;
        min-width: 140px;
        background: $white-primary;
        border: 1px solid $gray-line;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        padding: 4px;
        z-index: 1100;
    }

    .profile-dropdown-item {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        padding: 8px 12px;
        border: none;
        border-radius: 6px;
        background: transparent;
        font-size: 14px;
        color: $red-primary;
        cursor: pointer;
        text-align: left;

        &:hover {
            background-color: $gray-tab;
        }
    }

    .profile-logout-icon {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        color: $red-primary;
    }

    .navbar-guest-content {
        width: 100%;
    }

    .navbar .icon-arrow-left {
        margin-left: 20px;
        margin-top: 6px;
        text-align: center;
        width: 30px;
        height: 30px;
        background-size: 16px 16px;
        background-repeat: no-repeat;
        background-position: center center;
        display: block;
    }

    .navbar .logo {
        height: 35px;
        margin-top: 3px;
    }

    .login {
        background-color: $white-primary;
        position: relative;
        top: 5px;
        cursor: pointer !important;
    }

    .truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    @keyframes ping {
        75%, 100% {
            transform: scale(2);
            opacity: 0;
        }
    }
</style>
